import * as moment from 'moment';

export function formatDate (fechaString) {
    let trLocale = require('moment/locale/es');
    moment.locale('es', trLocale);

    return moment(fechaString).format('LL');
}
export function getTopicTitle (topic) {
    return topic.title.replace(/_/g, '-').replace(/ /g, '-');
}
export function getHumanUrl (topic) {
    let titlePrefix = topic.id ? topic.id + '_' : '';
    return titlePrefix + topic.title.replace(/_/g, '-').replace(/ /g, '-');
}
export function getHumanTime (time) {
    let diff = moment().diff(moment(time));
    let duration = moment.duration(diff);
    let humanDuration = {
        year: duration.asYears(),
        month: duration.asMonths(),
        week: duration.asWeeks(),
        days: duration.asDays(),
        hours: duration.asHours(),
        minutes: duration.asMinutes()
    };
    if (humanDuration.year > 1) {
        let years = Math.round(humanDuration.year);
        return 'Hace ' + years + (years === 1 ? ' año' : ' años');
    }
    if (humanDuration.month > 1) {
        let minutes = Math.round(humanDuration.month);
        return 'Hace ' + minutes + (minutes === 1 ? ' mes' : ' meses');
    }
    if (humanDuration.week > 1) {
        let weeks = Math.round(humanDuration.week);
        return 'Hace ' + weeks + (weeks === 1 ? ' semana' : ' semanas');
    }
    if (humanDuration.days > 1) {
        let days = Math.round(humanDuration.days);
        return 'Hace ' + days + (days === 1 ? ' dia' : ' dias');
    }
    if (humanDuration.hours > 1) {
        let hours = Math.round(humanDuration.hours);
        return 'Hace ' + hours + (hours === 1 ? ' hora' : ' horas');
    }
    if (humanDuration.minutes > 1) {
        let minutes = Math.round(humanDuration.minutes);
        return 'Hace ' + minutes + (minutes === 1 ? ' minuto' : ' minutos');
    }
    return 'Hace un momento';
}
export function copy (o) {
    let output;
    let v;
    let key;
    output = Array.isArray(o) ? [] : {};
    for (key in o) {
        v = o[key];
        output[key] = (typeof v === 'object') ? copy(v) : v;
    }
    return output;
}
export function completeOptions (inputOptions) {
    let options = copy(inputOptions);
    for (let i = 1; i < 6; i++) {
        let currentOption = options.find((option) => parseInt(option.position) === i);
        if (!currentOption) {
            options.push({
                position: i.toString(),
                sentence: ''
            });
        }
    }
    return options.sort((a, b) => a.position - b.position);
}



// WEBPACK FOOTER //
// ./src/Utilities.js